import styled from "styled-components";
import LogoImageOverflowDesktop from "@theme/assets/overflow-linear.png";
import React from "react";

const OverflowLogoWrapper = styled.div`
  width: 150px;
  display: block;
  
  img {
    display: block;
    max-height: 30px;
  }
`;

export const OverflowLogo = () => (
  <OverflowLogoWrapper>
    <img src={LogoImageOverflowDesktop} alt="logo" />
  </OverflowLogoWrapper>
);